/*
 * Authors: mariushirjanu
 * Created: 14/12/2023
 */
import { Component, Type } from '@angular/core';
import { IDetailCellRendererParams } from 'ag-grid-community';
import { AgFrameworkComponent } from 'ag-grid-angular/lib/interfaces';
import { InputsType } from 'ng-dynamic-component/lib/io';

export interface IDetailCellRendererParamsExtended extends IDetailCellRendererParams {
  message?:string;
  component?:Type<unknown>;
  onCellValueChanged:Function;
}

/**
 * AgDetailComponent renders either a custom component or HTML message based on provided parameters.
 *
 * @selector ag-detail
 * @template AgDetailComponent
 */
@Component({
  selector: 'ag-detail',
  template: `
    <ng-container *ngIf="params?.message; else renderComponent">
        <div [innerHTML]="params.message"></div>
    </ng-container>
    <ng-template #renderComponent>
        <ndc-dynamic [ndcDynamicComponent]="params?.component" [ndcDynamicInputs]="inputs"></ndc-dynamic>
    </ng-template>
  `
})
export class AgDetailComponent implements AgFrameworkComponent<IDetailCellRendererParamsExtended> {
  public params!:IDetailCellRendererParamsExtended;
  public component:Type<unknown>;
  public inputs:InputsType;

  public agInit(params:IDetailCellRendererParamsExtended):void {
    this.params = params;
    this.inputs = {
      data: this.params?.data,
      rowId: this.params?.node?.parent?.rowIndex
    };

    this.component = this.params.component;
  }
}